<div *ngIf="executeDocumentCapture">
  <ng-container *ngIf="(processService.documentCaptureService$ | async) === alloyDocV">
    <app-alloy-journey></app-alloy-journey>
  </ng-container>
  <ng-container *ngIf="(processService.documentCaptureService$ | async) === socureDocV">
    <app-socure-webhooks></app-socure-webhooks>
  </ng-container>
</div>

<div #processingCard [hidden]="!(processService.displayDefaultProcessingArea$ | async)" 
    fxLayout="column" fxLayoutAlign="center center" 
    class="processing-card card" role="status" tabindex="-1">
  <div id="processing-logo-area">&nbsp;</div>

  <div class="detail-header">Your application is currently being reviewed.</div>
  <div class="detail-header">Please do not refresh this page.</div>
  <br/>
  <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>

  <div *ngIf="executeAlloyEvaluate">
    <app-alloy-evaluate [isAlloyEvaluateRequired]="true"></app-alloy-evaluate>
  </div>

  <div *ngIf="executeAlloyDocumentVerification">
    <app-alloy-evaluate [isAlloyEvaluateRequired]="false"></app-alloy-evaluate>
  </div>
</div>
